__turbopack_context__.v({
  "buttonTab": "TabList-module__jF6_LW__buttonTab",
  "navMenuVerticalTab": "TabList-module__jF6_LW__navMenuVerticalTab",
  "navMenuVerticalTabIcon": "TabList-module__jF6_LW__navMenuVerticalTabIcon",
  "tab": "TabList-module__jF6_LW__tab",
  "tabIcon": "TabList-module__jF6_LW__tabIcon",
  "tabIconWrapper": "TabList-module__jF6_LW__tabIconWrapper",
  "tabList": "TabList-module__jF6_LW__tabList",
  "tabListReversed": "TabList-module__jF6_LW__tabListReversed",
  "tabListVertical": "TabList-module__jF6_LW__tabListVertical",
  "thematicTab": "TabList-module__jF6_LW__thematicTab",
});
